import countryList from 'country-list'

const CUSTOM_COUNTRY_LIST = [
    { iso: 'GB-ENG', name: 'England' },
    { iso: 'GB-NIR', name: 'Northern Ireland' },
    { iso: 'GB-SCT', name: 'Scotland' },
    { iso: 'GB-WLS', name: 'Wales' },
]

const getCountryName = (iso: string) => {
    const country = countryList.getName(iso)
    if (country) {
        return country
    }
    return CUSTOM_COUNTRY_LIST.find((c) => c.iso === iso)?.name ?? iso
}

const getCountryOptions = () => {
    return [...countryList.getData(), ...CUSTOM_COUNTRY_LIST].map((c) => ({
        name: c.name,
        value: c.name,
    }))
}

export { getCountryName, getCountryOptions }
